import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Szybki start',
  description: 'Przejdź przez ten przewodnik, aby uruchomić jak najszybciej',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Preferencje powiadomień',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Godziny otwarcia i lokalizacja',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Tożsamość restauracji',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Ustawienia zamówień',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Konfiguracja menu',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing i lojalność',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Mój sklep',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Uruchomienie',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Ukończone',
  },
  toasts: {
    failed_to_load_onboarding: 'Nie udało się załadować kroków wdrożenia',
  },
};
